import API from '@services/API';

const AtividadeService = {
    filtrar: async (filtros) => await API.filters(`atividades`, filtros),
    listar: async () => await API.list(`atividades`),
  	listarPorId: async (id) => await API.list(`/atividades/${id}`),
    listarAtividadesPorColaborador: async (id) => await API.list(`/atividades/colaborador/${id}`),
    listarAtividadesPorProcesso: async (id) => await API.list(`/atividades/processo/${id}`),
    listarAtividadesPorColaboradorAndProcesso: async (colaborador,processo) => await API.list(`/atividades/colaborador/${colaborador}/processo/${processo}`),
    adicionar: async (atividade) => await API.add(`atividades`, atividade),
  	editar: async (id, atividade) => await API.edit(`atividades`, id, atividade),
  	excluir: async (id) => await API.remove(`atividades`,id),
    atualizarAtividadeColaborador: async (colaborador) => await API.add(`/atividades/processo/colaborador`,colaborador),
}

export default AtividadeService;
